import { Box, Paper, Typography } from '@mui/material';
import { PageContainer } from '@toolpad/core/PageContainer';
import type React from 'react';
import { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';

const TermsPage: React.FC = () => {
  const [termsText, setTermsText] = useState<string>('');

  useEffect(() => {
    fetch('/termsAndConditions.md')
      .then((response) => response.text())
      .then((text) => setTermsText(text))
      .catch(() => setTermsText('Failed to load terms and conditions.'));
  }, []);

  return (
    <PageContainer title="">
      <Paper sx={{ p: 3, mt: 0 }}>
        <Box sx={{ my: 4 }}>
          <ReactMarkdown
            components={{
              h2: ({ children }) => (
                <Typography component="h2" variant="h5" gutterBottom>
                  {children}
                </Typography>
              ),
              h3: ({ children }) => (
                <Typography component="h3" variant="h6" gutterBottom>
                  {children}
                </Typography>
              ),
              p: ({ children }) => (
                <Typography component="p" variant="body1" paragraph>
                  {children}
                </Typography>
              ),
            }}
          >
            {termsText}
          </ReactMarkdown>
        </Box>
      </Paper>
    </PageContainer>
  );
};

export default TermsPage;
